import axios from '@/api/$axios'
export default {
  list ({ page, perPage, creditsSupported }) {
    return axios.get(`/commodities`, {
      params: { page, perPage, creditsSupported }
    })
  },
  detail ({ id }) {
    return axios.get(`/commodities/${id}`)
  }
}
